﻿import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function PayCommissionModal({
  payCollabId,
  setPayCollabId,
  collabToPay,
  payAmount,
  setPayAmount,
  payMethod,
  setPayMethod,
  payCommission,
}: {
  payCollabId: string | null;
  setPayCollabId: (id: string | null) => void;
  collabToPay: any;
  payAmount: number;
  setPayAmount: (val: number) => void;
  payMethod: string;
  setPayMethod: (val: string) => void;
  payCommission: any;
}) {
  return (
    <Dialog
      open={payCollabId !== null}
      onOpenChange={(open) => !open && setPayCollabId(null)}
    >
      <DialogContent className="sm:max-w-[400px] bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader>
          <DialogTitle className="text-xl">Pagar Comissão</DialogTitle>
        </DialogHeader>
        {collabToPay && (
          <div className="space-y-4 mt-4">
            <div className="p-4 bg-slate-800 rounded-lg border border-slate-700">
              <p className="text-slate-400 text-sm">Colaborador</p>
              <p className="font-bold text-lg text-white">{collabToPay.name}</p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label className="text-slate-300">Valor a Pagar (R$)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={payAmount}
                  onChange={(e) =>
                    setPayAmount(parseFloat(e.target.value) || 0)
                  }
                  className="bg-slate-800 border-slate-700 text-xl font-bold text-emerald-400 h-12"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-slate-300">Forma de Pagamento</Label>
                <select
                  value={payMethod}
                  onChange={(e) => setPayMethod(e.target.value)}
                  className="bg-slate-800 border border-slate-700 text-slate-100 h-12 px-3 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500 font-semibold"
                >
                  <option value="PIX">Pix</option>
                  <option value="DINHEIRO">Dinheiro</option>
                  <option value="TRANSFERENCIA">Transferência Bancária</option>
                </select>
              </div>
            </div>

            <div className="pt-4 flex justify-end gap-2 border-t border-slate-800">
              <Button variant="ghost" onClick={() => setPayCollabId(null)}>
                Cancelar
              </Button>
              <Button
                disabled={payCommission.isPending || payAmount <= 0}
                onClick={() =>
                  payCommission.mutate({
                    collabId: collabToPay.id,
                    amount: payAmount,
                    collabName: collabToPay.name,
                    method: payMethod,
                  })
                }
                className="bg-emerald-600 hover:bg-emerald-700 font-bold"
              >
                {payCommission.isPending
                  ? "Processando..."
                  : "Confirmar Pagamento"}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
